import React from 'react'
import { BiCodeBlock } from 'react-icons/bi';
import { HiArrowNarrowRight } from 'react-icons/hi';
import './product.css';

const Product = () => {
  return (
    <div className='product section_padding'>
      <div className='product__heading'>
            <h1 className='title'>What We Deliver</h1>
            <p className='text'>We define business processes through ideation, creation, and optimization with a team of exceptional strategists.</p>
      </div>
      <div className='container'>
        <div className='product-card first-card'>
          <div className='icon'>
            <BiCodeBlock/>
          </div>
          <div>
            <h4>Product Development</h4>
            <p>We ideate and develop unique software solutions to help businesses meet their exact objectives.</p>
          </div>         
        </div> 
        
        <div className='product-card second-card'>
          <div className='icon'>
            <BiCodeBlock/>
          </div>
          <div>
            <h4>Product Development</h4>
            <p>We ideate and develop unique software solutions to help businesses meet their exact objectives.</p>
          </div>         
        </div> 

        <div className='product-card third-card'>
          <div className='icon'>
            <BiCodeBlock/>
          </div>
          <div>
            <h4>Product Development</h4>
            <p>We ideate and develop unique software solutions to help businesses meet their exact objectives.</p>
          </div>         
        </div> 
      </div>
    
      <div className='product-button'>
        <div className='product-button-content'>
          <a href='#product'>View Services </a>
          <HiArrowNarrowRight className='arrow-icon' />

        </div>
      </div>
    </div>
  )
}

export default Product